import { SearchBoxLocations } from './SearchBoxLocations';

export type { TypeSearchBoxLocationsProps } from './types';
export default SearchBoxLocations;
